import Vue from 'vue'
import Vuex from 'vuex'
import framework from './modules/framework'
import frameworktabs from './modules/frameworktabs'
import auth from './modules/auth'
import tabpanel from './modules/tabpanel'
import tags from './modules/tags'
import common from './modules/common'
import user from './modules/user'
import getters from './getters'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    framework,
    frameworktabs,
    auth,
    tabpanel,
		tags,
		common,
		user
  },
	getters,
  strict: debug,
  plugins: debug ? [createLogger()] : []
})


// WEBPACK FOOTER //
// ./src/vuex/store.js